import { PlanCard } from '@giffgaff/broadband-common'
import { ComponentProps } from 'react'

import theme from '@/theme/theme'

type ProfilePlanCardProps = ComponentProps<typeof PlanCard>

export function ProfilePlanCard({ children, ...props }: ProfilePlanCardProps) {
  return (
    <PlanCard
      sx={() => ({
        border: 0,
        borderRadius: theme.borderRadius.medium,
        flexGrow: 1,
        ['& > div']: {
          border: 0,
          backgroundColor: theme.colors.white,
        },
        ['& > .plan-card__top']: {
          paddingBottom: 0,
        },
        ['& > .plan-card__bottom']: {
          paddingTop: 0,
        },
      })}
      {...props}
    >
      {children}
    </PlanCard>
  )
}
